module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTk2MCAyMjR2NTc2YTMyIDMyIDAgMCAxLTMyIDMySDk2YTMyIDMyIDAgMCAxLTMyLTMyVjIyNGEzMiAzMiAwIDAgMSAzMi0zMmg4MzJhMzIgMzIgMCAwIDEgMzIgMzJ6IG0tNjQgMzJIMTI4djUxMmg3NjhWMjU2eiIgZmlsbD0iIzAiIHAtaWQ9IjE1NzciPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Rectangle-outlined.svg
// module id = hVa8
// module chunks = 74